import AdzapRepository from "../../external/siaf-lite-adzap";
import SessionService from "../session.service";
class AdzapService {
  constructor() {
    this.sessionService = new SessionService();
  }

  async iniciarInstancia(body) {
    const { cnpjCpf } = this.sessionService.getEmpresa();
    return new AdzapRepository("/init-instance").post({
      ...body,
      sistema: "SIAFLITE",
      cnpjCpf,
    });
  }

  async statusInstancia() {
    const { cnpjCpf } = this.sessionService.getEmpresa();
    return new AdzapRepository("/status-connection").get({ cnpjCpf });
  }

  async enviarMensagem(body) {
    const { cnpjCpf } = this.sessionService.getEmpresa();
    return new AdzapRepository("/send-message").post({ ...body, cnpjCpf });
  }

  async enviarMensagemLote(body) {
    const { cnpjCpf } = this.sessionService.getEmpresa();
    return new AdzapRepository("/send-multiple-message-advanced").post({
      ...body,
      cnpjCpf,
    });
  }

  async enviarMensagemAgendada(body, scheduledFor) {
    const { cnpjCpf } = this.sessionService.getEmpresa();
    return new AdzapRepository(`/send-scheduled-message/${scheduledFor}`).post({
      ...body,
      cnpjCpf,
    });
  }

  async enviarMensagemLoteSimples(body) {
    const { cnpjCpf } = this.sessionService.getEmpresa();
    return new AdzapRepository("/send-multiple-message-simple").post({
      ...body,
      cnpjCpf,
    });
  }
}

export default AdzapService;
